import tracking from "../../../../common/ts/core/tracking";
import {FILTERS_UPDATED_EVENT_TYPE} from "../../../../common/ts/tracking/constants";
import {EventBus} from "../../../../common/ts/events/EventBus";

export interface TrackFiltersWebTrackingEventsData {
    filter: string;
    value: string;
}

export default class TrackFiltersWebTrackingEventsService {
    private readonly eventBus: EventBus;

    constructor(eventBus: EventBus) {
        this.eventBus = eventBus;
    }

    public execute(data: TrackFiltersWebTrackingEventsData): void {
        this.eventBus.emit(new tracking.TrackWebTrackingEvent({
                type: FILTERS_UPDATED_EVENT_TYPE,
                serpUrl: window.location.href,
                filters: {
                    [data.filter]: data.value
                },
            })
        );
    }

}
